import { Navigate } from 'react-router-dom';

export default function SEO() {
  // Redirect to the Overview sub-page
  return <Navigate to="/seo/overview" replace />;
}